import { chakra } from '@chakra-ui/react'

import { shouldForwardProp } from 'src/utils/should-forward-prop'

const SESSION_DETAILS_HEIGHT_DESKTOP = 40
const SESSION_DETAILS_HEIGHT_MOBILE = 72

export const Panel = chakra('div', {
    baseStyle: ({ theme }) => ({
        width: '100%',
        height: `${SESSION_DETAILS_HEIGHT_DESKTOP}px`,
        padding: '8px 0',

        [`@container (max-width: ${theme.breakPoints.mobilePhoneMaxWidth}px)`]: {
            height: `${SESSION_DETAILS_HEIGHT_MOBILE}px`,
            paddingLeft: '20px',
            paddingRight: '20px',
        },
    }),
})

type ContentLimiterProps = { $maxWidth: number }
export const ContentLimiter = chakra<'div', ContentLimiterProps>('div', {
    baseStyle: ({ $maxWidth, theme }) => ({
        width: '100%',
        maxWidth: `${$maxWidth}px`,
        margin: '0 auto',
        display: 'flex',
        gap: '8px',
        color: theme.palette.toolbar.sessionDetailsColor,
        fontSize: '14px',
        lineHeight: '24px',

        [`@container (max-width: ${theme.breakPoints.mobilePhoneMaxWidth}px)`]: {
            flexDirection: 'column',
            fontSize: '16px',
        },
    }),
    shouldForwardProp,
})

export const Timestamp = chakra('div', {
    baseStyle: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
})

export const Ellipse = chakra('span', {
    baseStyle: ({ theme }) => ({
        width: '5px',
        height: '5px',
        backgroundColor: theme.palette.toolbar.sessionDetailsColor,
        borderRadius: '50%',
    }),
})

export const Duration = chakra('div', {
    baseStyle: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
    },
})
